import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSonarsourceComponent } from './simple-icons-sonarsource.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSonarsourceComponent ],
    exports:      [ SimpleIconsSonarsourceComponent ],
    bootstrap:    []
})
export class SimpleIconsSonarsourceModule {}
